import { render } from "./AddEditJob.vue?vue&type=template&id=1007a520"
import script from "./AddEditJob.vue?vue&type=script&lang=js"
export * from "./AddEditJob.vue?vue&type=script&lang=js"

import "./AddEditJob.vue?vue&type=style&index=0&id=1007a520&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__